/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Promotion14Inputs */

const en__field_enum_icsrm_promotion14 = /** @type {(inputs: _Field_Enum_Icsrm_Promotion14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promotion`)
};

const de__field_enum_icsrm_promotion14 = /** @type {(inputs: _Field_Enum_Icsrm_Promotion14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promotion`)
};

/**
* | output |
* | --- |
* | "Promotion" |
*
* @param {_Field_Enum_Icsrm_Promotion14Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_promotion14 = /** @type {((inputs?: _Field_Enum_Icsrm_Promotion14Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Promotion14Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_promotion14(inputs)
	return de__field_enum_icsrm_promotion14(inputs)
});
export { _field_enum_icsrm_promotion14 as "_field_enum_ICSRM_PROMOTION" }